<app-add-edit-task *ngIf="contextIdDto"
                   [contextIdDto]="contextIdDto"
                   [visible]="visible">
</app-add-edit-task>